module.exports = __webpack_public_path__ + "static/media/CRO5_EDITSINGLE2.81b0419a.mp4";